import React, { useEffect, useState } from "react";
import axios from "axios";
import SitePage from "../SitePage";
import { productPath } from "../../lib/productSlug";
import { Link } from "react-router-dom";
import { Camera } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LookbookPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/products`)
      .then((r) => setProducts(r.data || []))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, []);

  // Prefer limited editions + bestseller for a curated visual grid
  const curated = [...products]
    .sort((a, b) => (b.limited ? 1 : 0) - (a.limited ? 1 : 0) || (b.bestseller ? 1 : 0) - (a.bestseller ? 1 : 0))
    .filter((p) => p.image)
    .slice(0, 12);

  return (
    <SitePage
      testId="lookbook-page"
      breadcrumb="Brand"
      breadcrumbLabel="Lookbook"
      eyebrow="LOOKBOOK / 図録"
      title="Sotto la"
      accent="teca"
      subtitle="Le foto delle nostre statue e action figure quando le apriamo per il controllo qualità. Zero photoshop, zero abbellimenti — solo luce, ombra e il pezzo così com&apos;è."
      wide
    >
      {loading ? (
        <div className="text-center py-32 font-heading text-3xl text-zinc-500 uppercase">...</div>
      ) : curated.length === 0 ? (
        <div data-testid="lookbook-empty" className="text-center py-24 border-2 border-dashed border-zinc-800">
          <Camera className="w-10 h-10 text-zinc-600 mx-auto mb-4" />
          <div className="font-heading uppercase text-xl text-zinc-500">Lookbook in preparazione</div>
          <div className="text-sm text-zinc-600 mt-2">Torna presto: stiamo scattando i nuovi arrivi.</div>
        </div>
      ) : (
        <>
          <div data-testid="lookbook-grid" className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {curated.map((p, idx) => (
              <Link
                key={p.id}
                to={productPath(p)}
                data-testid={`lookbook-item-${p.id}`}
                className={`group relative overflow-hidden border-2 border-zinc-800 hover:border-yellow-400 transition-all ${
                  idx % 5 === 0 ? "col-span-2 row-span-2" : ""
                }`}
              >
                <div className="aspect-square bg-black overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title}
                    loading="lazy"
                    className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black via-black/70 to-transparent p-4 opacity-0 group-hover:opacity-100 transition">
                  <div className="text-[10px] uppercase tracking-widest text-yellow-400 font-heading">{p.category}</div>
                  <div className="font-heading uppercase text-white text-sm mt-1 line-clamp-2">{p.title}</div>
                </div>
              </Link>
            ))}
          </div>

          <div className="mt-12 text-center border-t-2 border-zinc-800 pt-10">
            <p className="text-zinc-500 italic max-w-xl mx-auto mb-6">
              Ogni pezzo è fotografato dopo il quality check. Se lo vedi qui, è pronto per partire — o già in vetrina a Viareggio.
            </p>
            <Link to="/shop" data-testid="lookbook-cta-shop" className="skew-btn bg-yellow-400 text-black font-heading uppercase text-sm px-6 py-3 border-2 border-yellow-400 hover:bg-black hover:text-yellow-400 transition inline-flex items-center gap-2">
              <span>Vai al catalogo completo</span>
            </Link>
          </div>
        </>
      )}
    </SitePage>
  );
}
